export const TAB_LABELS = {
  footprint: "Footprint",
  products: "Product BOM Requests",
  customers: "Emissions Requests",
  suppliers: "Suppliers",
  "agent-activity": "Agent Activity"
};
